module.exports = __webpack_public_path__ + "static/media/finternet-button.5716003f.svg";